import { render, staticRenderFns } from "./TotalLoss.vue?vue&type=template&id=e75f2f9e&"
import script from "./TotalLoss.vue?vue&type=script&lang=js&"
export * from "./TotalLoss.vue?vue&type=script&lang=js&"
import style0 from "./TotalLoss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports